import { gql } from 'apollo-boost';

const createChatMutation = gql`
  mutation createChat($title: String!, $userIds: [String]!, $teamId: String) {
    startGroupChat(name: $title, userIds: $userIds, teamId: $teamId)
  }
`;

export default createChatMutation;
